import { render, staticRenderFns } from "./PhoneTools.vue?vue&type=template&id=b8740a8a&"
import script from "./PhoneTools.vue?vue&type=script&lang=js&"
export * from "./PhoneTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports